export default __webpack_public_path__ + "media/images/features/ana/balloon1-c6bf05be68b62c08e09729a16a92ed82.png";